module.exports = __webpack_public_path__ + "img/tn.f07a886c.svg";